import React, { useState } from 'react'
import PropTypes from 'prop-types';
import CTAButton from '../CTAButton/CTAButton'
import { Field } from '../Field/Field';
import { toast } from 'react-toastify';
import FlashMessage from '../FlashMessage/Message'
import CTAAnchorTag from '../CTAAnchorTag/CTAAnchorTag'
import './CreateApplicationRecord.scss'


function CreateApplicationRecord({ handleClose = () => { }, numSelected = 0, allScholarships = [], showSelectedCount = false, handleBulkApplicationCreate = () => { } }) {

  const [scholarship, setScholarship] = useState({ label: "", value: "" })
  const handleSubmit = (scholarship) => {
    if (showSelectedCount && scholarship?.value) {
      handleBulkApplicationCreate(scholarship?.value)
    } else {
      toast.error(<FlashMessage type='error' message='Please select program' />)
    }
  }

  return (
    <div className="create-application-page">
      <div className="create-application-page__header">
        <div>
          <h1 className='H1DesktopGreen create-application-title'>Create Draft Applications</h1>
        </div>
        <div>
          <CTAAnchorTag className="event-head H6DesktopGrey close-btn" handleClick={handleClose}>X</CTAAnchorTag>
        </div>
      </div>
      <div className='BodyDefaultBoldBlack create-application-sub-title'>Please select one of your programs from the dropdown menu below. By clicking 'Create Applications,' a draft application will be generated under that program for each of the selected applicants. For additional details and instructions, click <a className='create-application-sub-title__hyperlink-text' href='https://help.mykaleidoscope.com/article/181-program-management-creating-draft-applications' target='_blank'>here</a>.</div>
      {showSelectedCount && <div className='BodyDefaultBoldBlack'>{numSelected} Applicants Selected</div>}
      <div className="create-application-page__content">
        <Field
          className='field-group__field-full'
          type='select'
          label=''
          options={allScholarships}
          placeholder='Select Program'
          value={scholarship}
          handleChange={(val) => setScholarship(val)}
        />
      </div>
      <div className="create-application-page__footer">
        <CTAButton id='status-page__cta' type='tertiary' onClick={() => handleSubmit(scholarship)}>
          Create Applications
        </CTAButton>
      </div>
    </div>
  )
}
// handle propTypes
CreateApplicationRecord.propTypes = {
  handleClose: PropTypes.func,
  numSelected: PropTypes.number,
  allScholarships: PropTypes.array,
  showSelectedCount: PropTypes.bool,
  handleBulkApplicationCreate: PropTypes.func
};

export default CreateApplicationRecord